.microphoneButton {
  height: 40px;
  width: 40px;
  padding-inline-start: 6px;
  padding-bottom: 8px;
  background-color: var(--composerBg);
  border: none;
}
.microphoneButton span {
  display: block;
  width: 25px;
  height: 25px;
  margin-top: 7.5px;
  -webkit-mask-image: url(./images/microphone.svg);
  -webkit-mask-size: contain;
  background-color: var(--composerPlaceholderText);
}
.microphoneButton span:hover {
  background-color: var(--buttonSecondaryText);
}

.audioRecorder {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: stretch;
  flex-grow: 1;
  margin-inline-start: 10px;
}
.audioRecorder p {
  margin: 12px 0 0 3px;
}
.audioRecorder .microphoneButton span {
  animation: pulse 1.5s infinite ease-in-out;
}
@keyframes pulse {
  0% {
    background-color: rgba(235, 76, 76, 0.3450980392);
  }
  50% {
    background-color: #d70b0b;
  }
  100% {
    background-color: rgba(235, 76, 76, 0.3450980392);
  }
}
.audioRecorder .cancel,
.audioRecorder .stopRecording {
  padding: 4px;
  height: 32px;
  margin-top: 4px;
  width: 85px;
  border-radius: 5px;
  border: none;
  margin-inline-start: 16px;
}
.audioRecorder .cancel.stopRecording,
.audioRecorder .stopRecording.stopRecording {
  background-color: var(--buttonPrimaryBackground);
  color: #fff;
  margin-inline-end: 40px;
}
.audioRecorder .cancel.stopRecording:hover,
.audioRecorder .stopRecording.stopRecording:hover {
  background-color: var(--buttonPrimaryHover);
}
.audioRecorder .cancel.cancel,
.audioRecorder .stopRecording.cancel {
  background-color: var(--buttonSecondaryBackground);
  color: var(--buttonSecondaryText);
  border: 1px solid #ccc;
}
.audioRecorder .cancel.cancel:hover,
.audioRecorder .stopRecording.cancel:hover {
  background-color: var(--buttonSecondaryHover);
}

.timer {
  margin-top: 12px;
}

.volumeBarContainer {
  flex: 1;
  padding-inline-end: 10px;
}

.volumeBarContainer .volumeBar,
.volumeBarCompact .volumeBar {
  display: flex;
  position: relative;
  margin: 15px 20px 0 15px;
  height: 12px;
  width: 100%;
  max-width: 250px;
  min-width: 60px;
}
.volumeBarContainer .volumeBar .mask,
.volumeBarCompact .volumeBar .mask {
  display: flex;
  width: 100%;
  z-index: 10;
  height: 12px;
  position: absolute;
  left: 0;
}
.volumeBarContainer .volumeBar .mask .step,
.volumeBarCompact .volumeBar .mask .step {
  display: flex;
  width: 10%;
  height: 10px;
  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
  border-bottom: 1px solid #bbb;
}
.volumeBarContainer .volumeBar .mask .step:last-child,
.volumeBarCompact .volumeBar .mask .step:last-child {
  border-right: 1px solid #bbb;
}
.volumeBarContainer .volumeBar .level,
.volumeBarCompact .volumeBar .level {
  width: 100%;
  background-color: var(--composerBg);
  height: 10px;
  position: absolute;
  right: 0;
  z-index: 5;
}
.volumeBarContainer .volumeBar .colorBackground,
.volumeBarCompact .volumeBar .colorBackground {
  width: 100%;
  background: none;
  background: linear-gradient(to right, rgb(52, 237, 52), rgb(52, 237, 52) 50%, orange 75%, red 90%);
  height: 10px;
  position: absolute;
}

.volumeBarCompact .volumeBar {
  margin: 0;
  width: 56px;
  min-width: 56px;
  max-width: 56px;
}

.liveWaveformContainer {
  flex: 1;
  padding-inline-end: 10px;
}

.liveWaveform {
  display: block;
  margin: 15px 20px 0 15px;
  height: 12px;
  width: 100%;
  max-width: 250px;
  min-width: 60px;
  color: var(--colorPrimary);
}

.pauseButton {
  align-self: center;
  margin-inline-end: 4px;
  color: var(--composerPlaceholderText);
}
.pauseButton:hover {
  color: var(--buttonSecondaryText);
}

.holdHints {
  position: absolute;
  inset-inline-start: 8px;
  bottom: calc(100% + 6px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  pointer-events: none;
  z-index: 10;
}

.lockHint {
  padding: 4px 10px;
  border-radius: 12px;
  background-color: var(--bgPrimary);
  color: var(--textPrimary);
  border: 1px solid var(--separatorColor, #ccc);
  font-size: 13px;
}

.cancelHint {
  padding: 4px 10px;
  border-radius: 12px;
  background-color: var(--bgPrimary);
  color: var(--textSecondary, var(--textPrimary));
  border: 1px solid var(--separatorColor, #ccc);
  font-size: 13px;
}
.cancelHint[data-armed=true] {
  color: #fff;
  background-color: #d70b0b;
  border-color: #d70b0b;
}

.previewControls {
  flex: 1;
  min-width: 0;
  align-self: center;
  padding-inline-end: 10px;
}

.recActions {
  display: contents;
}

.micCluster {
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: center;
  position: relative;
  flex-shrink: 0;
}

.noSoundHint {
  color: var(--colorDanger, #d70b0b);
  font-size: 12px;
  white-space: nowrap;
}

.micPicker {
  position: relative;
  display: flex;
  align-items: center;
}

.micPickerButton {
  color: var(--composerPlaceholderText);
}
.micPickerButton:hover {
  color: var(--buttonSecondaryText);
}
.micPickerButton[aria-expanded=true] {
  color: var(--buttonSecondaryText);
}

.micMenu {
  position: absolute;
  inset-inline-end: 0;
  bottom: calc(100% + 6px);
  z-index: 10;
  min-width: 260px;
  max-width: min(340px, 80vw);
  max-height: 240px;
  overflow-y: auto;
  padding: 4px;
  background-color: var(--bgPrimary);
  color: var(--textPrimary);
  border: 1px solid var(--separatorColor, #ccc);
  border-radius: 8px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);
}

.micMenuItem {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 7px 8px;
  border: none;
  background: none;
  color: inherit;
  text-align: start;
  border-radius: 5px;
  cursor: pointer;
}
.micMenuItem:hover {
  background-color: var(--chatListItemSelectedBg);
}

.micCheck {
  flex: 0 0 auto;
  width: 14px;
  text-align: center;
}

.micLabel {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.micRowMeter {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

@media (max-width: 500px) {
  .audioRecorder {
    flex-wrap: wrap;
  }
  .previewControls {
    flex-basis: 100%;
  }
  .audioRecorder .cancel,
  .audioRecorder .stopRecording {
    width: auto;
    padding: 0 12px;
    height: 40px;
    margin-top: 0;
    margin-inline-start: 6px;
  }
  .audioRecorder .stopRecording.stopRecording {
    margin-inline-end: 6px;
  }
  .recActions {
    display: flex;
    margin-inline-start: auto;
    align-items: center;
  }
  .micMenu {
    position: fixed;
    inset-inline: 8px;
    bottom: 64px;
    min-width: 0;
    max-width: none;
  }
}